import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import classNames from 'classnames';

import {
  APIErrorPropType,
  GroupCreatePropType,
} from '../../../../common/types';

import isInteger from '../../../../common/isInteger';
import ConfirmDialog from '../../../../common/ConfirmDialog';

class GroupForm extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
    group: GroupCreatePropType.isRequired,
    error: APIErrorPropType,
    isArchived: PropTypes.bool.isRequired,
    edit: PropTypes.bool,
  };

  static defaultProps = {
    onRemove: null,
    error: null,
    edit: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      count: props.group.count.toString(),
      initialCount: props.group.count,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.group.id !== this.props.group.id) {
      this.setState({
        count: this.props.group.count.toString(),
        initialCount: this.props.group.count,
      });
    }
  }

  onNameChange = event => {
    const group = {
      ...this.props.group,
      name: event.target.value,
    };

    this.props.onChange(group);
  };

  onCountChange = event => {
    this.setState({ count: event.target.value });

    if (!isInteger(event.target.value)) return;

    const count = parseInt(event.target.value, 10);
    if (count < this.state.initialCount) return;

    const group = {
      ...this.props.group,
      count,
    };

    this.props.onChange(group);
  };

  deleteGroup = () => {
    this.props.onRemove();
  };

  render() {
    const { error, isArchived, edit, group, onSubmit } = this.props;
    const { count, initialCount } = this.state;
    const { name } = group;

    const countValid = isInteger(count);
    const countInteger = parseInt(count, 10);

    return (
      <form onSubmit={onSubmit}>
        <ConfirmDialog
          id="deleteConfirmDialog"
          icon={<i className="fas fa-trash-alt fa-3x text-primary" />}
          text={
            <FormattedHTMLMessage
              id="group-form-delete-confirm"
              defaultMessage="Oletko varma että haluat poistaa ryhmän <b>{name}</b>?"
              values={{ name }}
            />
          }
          onConfirm={this.deleteGroup}
        />

        <div className="form-group mb-4">
          <label htmlFor="name">
            <FormattedMessage
              id="group-form-name-label"
              defaultMessage="Ryhmän nimi"
            />
          </label>
          <input
            className="form-control"
            type="text"
            name="name"
            id="name"
            value={name}
            onChange={this.onNameChange}
            required
          />
        </div>

        <div className="form-group mb-4">
          <label htmlFor="count">
            <FormattedMessage
              id="group-form-count-label"
              defaultMessage="Oppilasmäärä"
            />
          </label>
          <input
            className={classNames('form-control', {
              'is-invalid':
                !countValid ||
                countInteger < initialCount ||
                countInteger < 1 ||
                countInteger > 100,
            })}
            type="text"
            name="count"
            id="count"
            value={count}
            onChange={this.onCountChange}
            required
          />

          {!countValid && (
            <div className="invalid-feedback">
              <FormattedMessage
                id="question-form-must-be-number"
                defaultMessage="Syötteen pitää olla luku"
              />
            </div>
          )}

          {countInteger >= 1 && countInteger < initialCount && (
            <div className="invalid-feedback">
              <FormattedMessage
                id="group-form-count-cannot-reduce-size"
                defaultMessage="Ryhmän kokoa ei voi pienentää"
              />
            </div>
          )}

          {countInteger < 1 && (
            <div className="invalid-feedback">
              <FormattedMessage
                id="group-form-count-too-few"
                defaultMessage="Oppilaita pitää olla vähintään yksi"
              />
            </div>
          )}

          {countInteger > 100 && (
            <div className="invalid-feedback">
              <FormattedMessage
                id="group-form-count-too-many"
                defaultMessage="Oppilaita saa olla enintään 100"
              />
            </div>
          )}
        </div>

        <button
          type="submit"
          className="btn btn-primary btn-round btn-block mt-4"
          disabled={
            !name ||
            !countValid ||
            countInteger < initialCount ||
            countInteger < 1 ||
            countInteger > 100
          }
        >
          {edit ? (
            <FormattedMessage
              id="group-form-edit"
              defaultMessage="Tallenna muutokset"
            />
          ) : (
            <FormattedMessage
              id="group-form-create"
              defaultMessage="Luo ryhmä"
            />
          )}
        </button>

        {edit && (
          <>
            <hr className="mt-4 mb-3" />

            <h4 className="mt-0">
              <FormattedMessage
                id="group-form-dangerzone"
                defaultMessage="Vaara-alue"
              />
            </h4>

            <button
              className="btn btn-danger btn-round"
              type="button"
              data-toggle="modal"
              data-target="#deleteConfirmDialog"
              disabled={isArchived}
            >
              <FormattedMessage
                id="group-form-delete"
                defaultMessage="Poista ryhmä"
              />
            </button>
          </>
        )}

        {error && <span>{error.message}</span>}
      </form>
    );
  }
}

export default GroupForm;
